import { atom, useAtom } from 'jotai';
import { useMemo } from 'react';

const optimisticItemContentRects = atom(new Map<string, DOMRect>());

export const useOptimisticItemContentRects = () => {
  const [map, setMap] = useAtom(optimisticItemContentRects);

  return useMemo(
    () => ({
      has: map.has.bind(map),
      get: map.get.bind(map),
      entries: map.entries.bind(map),
      size: map.size,
      remove: (key: string) => {
        setMap((prev) => {
          const next = new Map(prev);
          next.delete(key);
          return next;
        });
      },
      add: (key: string, rect: DOMRect) => {
        setMap((prev) => {
          const next = new Map(prev);
          next.set(key, rect);
          return next;
        });
      },
    }),
    [map, setMap],
  );
};
